export default function styles(theme) {
  return {
    link: {
      ...theme.palette.text.gradient,
      textDecoration: "underline",
    },
    section: {
      alignItems: "center",
      justifyContent: "center",
      marginTop: 40,
      marginBottom: 120,
    },
    title: {
      color: theme.palette.text.primary,
      margin: "0 auto 0.5rem",
      display: "block",
      textAlign: 'center',
      padding:"0rem 0rem",
    },
    description: {
      margin: "auto",
      display: "block",
      textAlign: "center",
      color: theme.palette.text.tertiary,
      maxWidth: "40pc",
    },
    contactGrid: {
      display: "grid",
      gridGap: 30,
      gridTemplateColumns: "1fr 1fr",
      marginTop: theme.spacing(4),
      [theme.breakpoints.down("sm")]: {
        gridTemplateRows: "1fr 1fr",
        gridTemplateColumns: "1fr",
      },
    },
    contactForm: {
      width: "100%",
      background: theme.palette.primary.main,
      border: '1px solid rgba(121, 131, 150, 0.15)',
      display: "grid",
      gridTemplateRows: "repeat(5, auto)",
      borderRadius: "8px",
      padding: "1.5rem",
      [theme.breakpoints.down("sm")]: {
        padding: "1rem",
      },
    },
    textFieldOutline: {
      '& label.Mui-focused': {
        color: theme.palette.text.primary,
      },
      '& .MuiInput-underline:after': {
        borderBottomColor: theme.palette.text.primary,
      },
      "& .Mui-focused.MuiInputLabel-animated": {
        color: theme.palette.text.primary,
      },
    },
    btn: {
      width: "fit-content",
      borderRadius: 50,
    },
    options: {
      display: "grid",
      gridGap: 30,
      gridTemplateRows: "auto auto",
    },
    optionBlock: {
      background: theme.palette.primary.main,
      border: '1px solid rgba(121, 131, 150, 0.15)',
      padding: "1.5rem",
      width: "100%",
      borderRadius: "8px",
      [theme.breakpoints.down("sm")]: {
        padding: "1rem",
      },
    },
    optionTitle: {
      color: theme.palette.text.primary,
    },
    optionInfo: {
      color: theme.palette.text.tertiary,
      marginBottom: theme.spacing(2),
    },
  };
}
